module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "add-icon.ca837662.svg";